import { render, staticRenderFns } from "./DocumentCalculatorApi.vue?vue&type=template&id=1c6b7b4f&scoped=true"
import script from "./DocumentCalculatorApi.vue?vue&type=script&lang=js"
export * from "./DocumentCalculatorApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6b7b4f",
  null
  
)

export default component.exports